const GUEST_ORDER_AUTH_KEY = "@guest_order_auth";

type GuestOrderAuth = {
  orderToken: string;
  orderHmac: string;
  updatedAt: string;
};

function canUseStorage(): boolean {
  return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

export function getGuestOrderAuth(): GuestOrderAuth | null {
  if (!canUseStorage()) return null;
  const raw = localStorage.getItem(GUEST_ORDER_AUTH_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<GuestOrderAuth>;
    if (!parsed.orderToken || !parsed.orderHmac) return null;
    return {
      orderToken: parsed.orderToken,
      orderHmac: parsed.orderHmac,
      updatedAt: parsed.updatedAt || new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

export function setGuestOrderAuth(orderToken: string, orderHmac: string): void {
  if (!canUseStorage()) return;
  const token = String(orderToken || "").trim();
  const hmac = String(orderHmac || "").trim();
  if (!token || !hmac) return;
  const payload: GuestOrderAuth = {
    orderToken: token,
    orderHmac: hmac,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(GUEST_ORDER_AUTH_KEY, JSON.stringify(payload));
}

export function clearGuestOrderAuth(): void {
  if (!canUseStorage()) return;
  localStorage.removeItem(GUEST_ORDER_AUTH_KEY);
}
